import Card from "../../card/Card";
import {useEffect, useRef} from "react";
import {useActions} from "../../../hooks/useActions";
import {useTypedSelector} from "../../../hooks/useTypedSelector";

function CardContainer({side, tableKey, card, targetClass}: any) {

    const elementRef = useRef(null);
    const {coords} = useTypedSelector(state => state.animation);
    const {setCoords} = useActions();

    useEffect(() => {
        if (elementRef.current) {
            // @ts-ignore
            const rect = elementRef.current.getBoundingClientRect();

            if (!rect) {
                return;
            }
            const key = 'cell_' + side + '_' + tableKey;
            const elementCoords = {
                x: Math.round(rect.left + rect.width / 2),
                y: Math.round(rect.top + rect.height / 2),
            }
            coords[key] = elementCoords;
            setCoords(coords);
        }
    },[]);

    const ua = typeof navigator !== 'undefined'
        ? navigator.userAgent.toLowerCase()
        : '';

    const isFirefox = ua.includes('firefox') || ua.includes('fxios');

    return isFirefox ? (
        <Card card={card} isSmall targetClasses={targetClass} isBattle/>
    ) : (
        <div className={'box buc_cell_' + tableKey}>
            <figure ref={elementRef} className="front">
                <Card card={card} isSmall targetClasses={targetClass} isBattle/>
            </figure>
            <figure className="back">&#8203;</figure>
            <figure className="right">&#8203;</figure>
            <figure className="left"> &#8203;</figure>
            <figure className="bottom">&#8203;</figure>
        </div>
    );
}

export default CardContainer;